import React from "react"
import {connect} from "react-redux"
import Styles from "../uploadFile/uploadFile.less"
import pdfSvg from "../../../static/pic/pdfSvg.svg"
import wordSvg from "../../../static/pic/wordSVG.svg"
import picSvg from "../../../static/pic/picSvg.svg"
import ofdSvg from "../../../static/pic/ofdSvg.svg"
import {Model, ReducerState} from "../../../reducer/interface/baseInterface"
import {UseFileInfo} from "../../../function/hooks/useDataFromRedux"
import {ComparisonStatus} from "../../../reducer/interface/controlInterface"
import {FileInfo} from "../../../reducer/interface/fileInterface"

interface StaticViewProps {
    type: string
    model: Model
    loading: boolean
    comparisonStatus: ComparisonStatus
}

interface UploadFileCommponentProps {
    fileInfo: FileInfo
}

const StaticView: React.FunctionComponent<StaticViewProps> = ({type, loading}) => {
    const [baseInfo, compareInfo] = [UseFileInfo().useDisplayBase(), UseFileInfo().useDisplayCompare()]
    return (
        <div className={Styles.uploadFileBox}>
            <div className={Styles.uploadFileInnerBox}>
                <div className={Styles.header}>{type === "Base" ? "原文档" : "比对文档"}</div>
                <div className={Styles.body}>
                    <div style={{display: loading === true ? "block" : "none"}} className={Styles.uploadMark}>
                        <div className={Styles.uploadSlider} />
                    </div>
                    <div className={Styles.uploadFilePath}>
                        <UploadFileCommponent fileInfo={type === "Base" ? baseInfo : compareInfo} />
                    </div>
                </div>
                <div className={Styles.footer}>
                    <span>不超过10M、500页，支持pdf、doc、docx 、jpg、jpeg、bmp、png、ofd格式。</span>
                    {/* <UploadTips text={"图片支持png,jpg,jpeg,bmp,tif,tiff格式。"} />*/}
                </div>
            </div>
        </div>
    )
}
const UploadFileCommponent: React.FunctionComponent<UploadFileCommponentProps> = ({fileInfo}) => {
    const fileType = fileInfo.type
    const fileName = fileInfo.name
    const getPic = () => {
        switch (fileType) {
            case "pdf":
                return pdfSvg
            case "doc":
                return wordSvg
            case "docx":
                return wordSvg
            case "png":
                return picSvg
            case "jpg":
                return picSvg
            case "jpeg":
                return picSvg
            case "tif":
                return picSvg
            case "tiff":
                return picSvg
            case "bmp":
                return picSvg
            case "ofd":
                return ofdSvg
            default:
                return picSvg
        }
    }
    return (
        <div className={Styles.uploadFileCommponent}>
            <div className={Styles.hasDataCommponent}>
                <div className={Styles.hasDataBody}>
                    <div className={Styles.fileInfo}>
                        <div className={Styles.fileType}>
                            <img src={getPic()} />
                        </div>
                        <span title={fileName} className={Styles.fileName}>
                            {fileName}
                        </span>
                    </div>
                </div>
                <div className={Styles.hasDataFooter} />
            </div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        model: state.global.model,
        loading: state.control.loading,
        comparisonStatus: state.control.comparisonStatus,
    }
})(StaticView)
